module.exports = __webpack_public_path__ + "img/sweden-endocrine-nutritional-metabolic-diseases-male.19ae30dc.png";